import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environmentConfig } from '../../environment';
import { AuthService } from '../services/auth.service';
import { HttpHeaders } from '@angular/common/http';
import { getAuth } from 'firebase/auth';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BillingReviewPivotService {
    private apiUrl = environmentConfig.apiBaseUrl;

    constructor(private http: HttpClient, private authService: AuthService) { }


    private fetchAuthenticated(url: string, method: 'GET' | 'POST' | 'PUT', token: any, bodyData?: any,): Observable<any> {
        const auth = getAuth();
        const user = auth.currentUser;

        return new Observable<any>(observer => {
            const headers = new HttpHeaders({
                'Authorization': `Bearer ` + token
            });

            const httpOptions = { headers };
            let httpCall: Observable<any>;

            if (method === 'GET') {
                httpCall = this.http.get(url, httpOptions);
            } else if (method === 'POST') {
                httpCall = this.http.post(url, bodyData, httpOptions);
            } else if (method === 'PUT') {
                httpCall = this.http.put(url, bodyData, httpOptions);
            } else {
                observer.error('Unsupported method');
                return;
            }

            httpCall.subscribe({
                next: data => {
                    //console.log('✅ Response:', data);
                    observer.next(data);
                },
                error: err => {
                    console.error('❌ HTTP Error:', err);
                    observer.error(err);
                },
                complete: () => observer.complete()
            });
        });
    }

    getClientsList(token: string): Observable<string[]> {
        const url = `${this.apiUrl}/api/pivotreview/getclientslist`;
        return this.fetchAuthenticated(url, 'GET', token).pipe(
            map((res: any) => (Array.isArray(res) ? (res as string[]) : []))
        );
    }

    getViewData(token: string): Observable<any> {
        const url = `${this.apiUrl}/api/pivotreview/getdata`;
        return this.fetchAuthenticated(url, 'GET', token);
    }

    updatePivotReviewData(body: any, token: string): Promise<any> {
        const url = `${this.apiUrl}/api/pivotreview/updatedata`;
        return this.fetchAuthenticated(url, 'POST', token, body).toPromise();
    }

    getReviewRefCols(token: string, clientIds?: string): Promise<any> {
        const qs = clientIds ? `?client_ids=${encodeURIComponent(clientIds)}` : '';
        const url = `${this.apiUrl}/api/pivotreview/refcols${qs}`;
        return this.fetchAuthenticated(url, 'GET', token).toPromise();
    }

    getUserIdsForTask(token: string, taskId: number): Observable<number[]> {
        const url = `${this.apiUrl}/api/pivotreview/users_for_task?task_id=${encodeURIComponent(taskId)}`;
        return this.fetchAuthenticated(url, 'GET', token).pipe(
            map((res: any) =>
                Array.isArray(res) ? res.map((x: any) => Number(x)).filter((n: number) => Number.isFinite(n)) : []
            )
        );
    }

    getTaskIdsForUser(token: string, userId: number, clientId: number) {
        const url =
            `${this.apiUrl}/api/pivotreview/tasks_for_user` +
            `?user_id=${encodeURIComponent(userId)}` +
            `&client_id=${encodeURIComponent(clientId)}`;
        return this.fetchAuthenticated(url, 'GET', token).pipe(
            map((res: any) => {
                const arr = Array.isArray(res?.tasks) ? res.tasks : (Array.isArray(res) ? res : []);
                return arr.map((x: any) => Number(x)).filter((n: number) => Number.isFinite(n));
            })
        );
    }
}